import { Grid, Typography } from 'seagull';
import { AgreementName } from "../../../../components/AgreementStudio/AgreementName";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { agreementNameValidator } from "../../../../business-logic/validators";
import styles from "./Cells.module.scss";
import { getAgreementName } from "../EditDraftsTable.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AgreementNameCell(_ref) {
  let {
    draft,
    index,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const onClick = () => onOpenModal({
    shouldSubmit: async draft => Promise.resolve(agreementNameValidator(draft.title()) === true),
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Agreement name',
        testid: "edit-agreement-name-modal",
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(Grid, {
          align: "center",
          className: styles.agreementName,
          children: /*#__PURE__*/_jsx(AgreementName, {
            agreementTitle: draft.title(),
            setAgreementTitle: title => setDraft(draft.setTitle(title)),
            showWarning: true,
            setAgreementTitleValid: () => {},
            label: "Agreement name",
            testid: "edit-agreement-name-modal"
          })
        })
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testid: "edit-agreement-name-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      ellipsis: true,
      "data-testid": "agreement-name-".concat(index),
      variant: draft.title() ? 'paragraph1' : 'paragraph2',
      skin: draft.title() ? 'standard' : 'secondary',
      children: getAgreementName(draft)
    })
  });
}